export const errorMessage = {
  '-1': 'Sua sessão expirou, por favor faça login novamente',
  '-2': 'Timeout da requisição',
};

export const successMessage = {
  1002: 'A recuperação de senha foi iniciada com sucesso. Um e-mail será enviado com informações para recuperar a senha',
  1003: 'Alteração de senha efetuada com sucesso!',
};

export const GENERIC_ERROR_MESSAGE = 'Ocorreu um erro';
export const GENERIC_REQUEST_ERROR_MESSAGE = 'Não foi possível concluir a requisição';

export const USER_REGISTRATION_MESSAGES = {
  EMAIL_ALREADY_IN_USE: 'Email já utilizado em outra conta!',
  ROLE_NOT_FOUND: 'Perfil não encontrado!',
};

export const backendResponseCodes = {
  Success: {
    ExampleDoNotUse: {
      ExampleSuccessNameInBackend: {
        code: 0,
        description: {
          pt_br: '',
          en_us: '',
        },
      },
    },

    User: {
      UserRegisteredSuccessfully: {
        code: 1001,
        description: {
          pt_br: 'Usuário cadastrado.',
          en_us: 'User registered successfully.',
        },
      },
      UserLoggedInSuccessfully: {
        code: 1002,
        description: {
          pt_br: 'Usuário logado.',
          en_us: 'User logged in successfully.',
        },
      },
      UserLoggedOutSuccessfully: {
        code: 1003,
        description: {
          pt_br: 'Usuário deslogado.',
          en_us: 'User logged out successfully.',
        },
      },
      UserEmailValidatedSuccessfully: {
        code: 1004,
        description: {
          pt_br: 'Email confirmado.',
          en_us: 'User email validated successfully.',
        },
      },
      UserPasswordUpdatedSuccessfully: {
        code: 1005,
        description: {
          pt_br: 'Senha alterada.',
          en_us: 'User password updated successfully.',
        },
      },
      UserEditedSuccessfully: {
        code: 1006,
        description: {
          pt_br: 'Usuário editado.',
          en_us: 'User edited successfully.',
        },
      },
      PasswordResetMailSentSuccessfully: {
        code: 1007,
        description: {
          pt_br: 'Email de redefinição de senha enviado.',
          en_us: 'Password reset mail sent successfully.',
        },
      },
      PasswordRedefinedSuccessfully: {
        code: 1008,
        description: {
          pt_br: 'Senha redefinida.',
          en_us: 'Password redefined successfully.',
        },
      },
      AllUsersListedSuccessfully: {
        code: 1009,
        description: {
          pt_br: 'Usuários listados.',
          en_us: 'All users listed successfully.',
        },
      },
      UserFoundSuccessfully: {
        code: 1010,
        description: {
          pt_br: 'Usuário encontrado.',
          en_us: 'User found successfully.',
        },
      },
      UserDeletedSuccessfully: {
        code: 1011,
        description: {
          pt_br: 'Usuário excluído.',
          en_us: 'User deleted successfully.',
        },
      },
      UsersByTypeListedSuccessfully: {
        code: 1012,
        description: {
          pt_br: 'Usuários por tipo listados.',
          en_us: 'Users by type listed successfully.',
        },
      },
      ResendEmailConfirmationSuccessfully: {
        code: 1013,
        description: {
          pt_br: 'Email de confirmação reenviado.',
          en_us: 'Resend email confirmation successfully.',
        },
      },
      CustomerProfileFoundSuccessfully: {
        code: 1014,
        description: {
          pt_br: 'Perfil encontrado.',
          en_us: 'Customer profile found successfully.',
        },
      },
      CustomerProfileEditedSuccessfullyWithEmailChange: {
        code: 1015,
        description: {
          pt_br: 'Perfil editado com troca de email.',
          en_us: 'Customer profile edited successfully with email change.',
        },
      },
      CustomerProfileEditedSuccessfullyWithoutEmailChange: {
        code: 1016,
        description: {
          pt_br: 'Perfil editado sem troca de email.',
          en_us: 'Customer profile edited successfully without email change.',
        },
      },
      FederalRegistrationReadyToUse: {
        code: 1017,
        description: {
          pt_br: 'Documento já cadastrado no Campo Digital. Favor seguir com o login.',
          en_us: 'Federal registration ready to use.',
        },
      },
      TokenValidatedSuccessfully: {
        code: 1018,
        description: {
          pt_br: 'Token validado.',
          en_us: 'Token validated successfully.',
        },
      },
      TokenSendSuccessfully: {
        code: 1019,
        description: {
          pt_br: 'Um token de validação foi enviado.',
          en_us: 'Token send successfully.',
        },
      },
    },

    Matriculation: {
      ListedCustomerMatriculationsWithLands: {
        code: 2000,
        description: {
          pt_br: 'Matrículas e suas respectivas propriedades listadas.',
          en_us: 'Listed customer matriculations with lands successfully.',
        },
      },
      ListedActivatedCustomerMatriculationsWithLandOwners: {
        code: 2001,
        description: {
          pt_br: 'Matrículas (aprovadas) e seus respectivos proprietários listados.',
          en_us: 'Listed activated customer matriculations with land owners successfully.',
        },
      },
      ListedMatriculationWithLandOwners: {
        code: 2002,
        description: {
          pt_br: 'Matrículas e respectivos proprietários listados.',
          en_us: 'Listed matriculation with land owners successfully.',
        },
      },
      ListedMatriculationWithLands: {
        code: 2003,
        description: {
          pt_br: 'Matriculas e suas respectivas propriedades listadas.',
          en_us: 'Listed matriculation with lands successfully.',
        },
      },
    },

    Role: {
      ListedRoles: {
        code: 3000,
        description: {
          pt_br: 'Perfis listados.',
          en_us: 'Listed roles with sucesses.',
        },
      },
      ListedTypesWithRolesSuccessfully: {
        code: 3001,
        description: {
          pt_br: 'Tipos e perfis listados.',
          en_us: 'Listed types with roles successfully.',
        },
      },
      ListedTypesWithPermissionsSuccessfully: {
        code: 3002,
        description: {
          pt_br: 'Tipos e permissões listados.',
          en_us: 'Listed types with permissions successfully.',
        },
      },
      AllRolesListedSuccessfully: {
        code: 3003,
        description: {
          pt_br: 'Perfis listados.',
          en_us: 'All roles listed successfully.',
        },
      },
      RoleRegisteredSuccessfully: {
        code: 3004,
        description: {
          pt_br: 'Perfil cadastrado.',
          en_us: 'Role registered successfully.',
        },
      },
      RoleFoundSuccessfully: {
        code: 3005,
        description: {
          pt_br: 'Perfil encontrado.',
          en_us: 'Role found successfully.',
        },
      },
      RoleDeletedSuccessfully: {
        code: 3006,
        description: {
          pt_br: 'Perfil excluido.',
          en_us: 'Role deleted successfully.',
        },
      },
      RoleEditedSuccessfully: {
        code: 3007,
        description: {
          pt_br: 'Perfil editado.',
          en_us: 'Role edited successfully.',
        },
      },
      RoleUsersListedSuccessfully: {
        code: 3008,
        description: {
          pt_br: 'Os usuários associados ao perfil foram listados.',
          en_us: 'Role users listed successfully.',
        },
      },
      RoleUsersEditedSuccessfully: {
        code: 3009,
        description: {
          pt_br: 'Os usuários associados ao perfil foram editados.',
          en_us: 'Role users edited successfully.',
        },
      },
      ListedTypesWithUsersSuccessfully: {
        code: 3010,
        description: {
          pt_br: 'Tipos de perfis e respectivos usuários listados.',
          en_us: 'Listed types with users successfully.',
        },
      },
      DefaultRoleSetSuccessfully: {
        code: 3011,
        description: {
          pt_br: 'Perfil padrão definido.',
          en_us: 'Default role set successfully.',
        },
      },
    },

    Service: {
      ServicesListedSuccessfully: {
        code: 5000,
        description: {
          pt_br: 'Serviços listados.',
          en_us: 'Services listed successfully.',
        },
      },
      DynamicFieldsListedSuccessfully: {
        code: 5001,
        description: {
          pt_br: 'Campos dinâmicos listados.',
          en_us: 'Dynamic fields listed successfully.',
        },
      },
      ServiceRequestedSuccessfully: {
        code: 5002,
        description: {
          pt_br: 'Serviço solicitado.',
          en_us: 'Service requested successfully.',
        },
      },
      DataFromSAPUpdatedDuringServiceRequestSuccessfully: {
        code: 5003,
        description: {
          pt_br: 'Sistema atualizado com os dados do SAP.',
          en_us: 'Data from SAP updated during service request successfully.',
        },
      },
      AllStatusesListedSuccessfully: {
        code: 5004,
        description: {
          pt_br: 'Status listados',
          en_us: 'All statuses listed successfully.',
        },
      },
      ResponsableUserSetSuccessfully: {
        code: 5005,
        description: {
          pt_br: 'Usuário responsável modificado.',
          en_us: 'Responsable user set successfully.',
        },
      },
      ServiceRequestFoundSuccessfully: {
        code: 5006,
        description: {
          pt_br: 'Solicitação de serviço encontrada.',
          en_us: 'Service request found successfully.',
        },
      },
      ServiceRequestSuccessfullyUpdated: {
        code: 5007,
        description: {
          pt_br: 'Solicitação de serviço atualizada.',
          en_us: 'Service request successfully updated.',
        },
      },
      AllServiceRequestsListedSuccessfully: {
        code: 5008,
        description: {
          pt_br: 'Solicitações de serviços listadas.',
          en_us: 'All service requests listed successfully.',
        },
      },
      ServiceFlowListedSuccessfully: {
        code: 5009,
        description: {
          pt_br: 'Fluxo de serviços listado.',
          en_us: 'Service flow listed successfully.',
        },
      },
      ServiceRequestCancelledSuccessfully: {
        code: 5010,
        description: {
          pt_br: 'Solicitação de serviços cancelada.',
          en_us: 'Service request cancelled successfully.',
        },
      },
      AllServicesFilterListedSuccessfully: {
        code: 5011,
        description: {
          pt_br: 'Filtro de serviços listado.',
          en_us: 'All services filter listed successfully.',
        },
      },
      MaxPeriodOfDaysFilterGotSuccessfully: {
        code: 5012,
        description: {
          pt_br: 'Período máximo para filtro de serviços encontrado.',
          en_us: 'Max period of days filter got successfully.',
        },
      },
      ServiceRequestEditedSuccessfully: {
        code: 5013,
        description: {
          pt_br: 'Solicitação de serviço editada.',
          en_us: 'Service request edited successfully.',
        },
      },
      FinancialMaxPeriodOfDaysFilterGotSuccessfully: {
        code: 5014,
        description: {
          pt_br: 'Período máximo para filtro financeiro encontrado.',
          en_us: 'Max period of days filter got successfully.',
        },
      },
      SearchByImageDroneServiceSuccessfully: {
        code: 5015,
        description: {
          pt_br: 'Pesquisa por drone de imagem realizada.', // REVISAR
          en_us: 'Search by image drone service successfully.',
        },
      },
      NotesEditedSuccessfully: {
        code: 5016,
        description: {
          pt_br: 'Comentários editados.',
          en_us: 'Notes edited successfully.',
        },
      },
      NotesSavedSuccessfully: {
        code: 5017,
        description: {
          pt_br: 'Comentários salvos.',
          en_us: 'Notes saved successfully.',
        },
      },
      NotesDeletedSuccessfully: {
        code: 5018,
        description: {
          pt_br: 'Comentários deletados.',
          en_us: 'Notes deleted successfully.',
        },
      },
      AfterSalesServiceSuccessfullyAccepted: {
        code: 5019,
        description: {
          pt_br: 'Serviço pós-venda aceito.',
          en_us: 'After sales service successfully accepted.',
        },
      },
      AfterSalesServiceSuccessfullyRefused: {
        code: 5020,
        description: {
          pt_br: 'Serviço pós-venda recusado.',
          en_us: 'After sales service successfully refused.',
        },
      },
    },

    Land: {
      LandFieldRegisteredSuccessfully: {
        code: 6000,
        description: {
          pt_br: 'Talhão cadastrado.',
          en_us: 'Land field registered successfully.',
        },
      },
      LandFieldsRetrivedByLandSuccessfully: {
        code: 6001,
        description: {
          pt_br: 'Talhões por propriedade listados.',
          en_us: 'Land fields retrieved by land successfully.',
        },
      },
      LandOwnersRetrivedByLandSuccessfully: {
        code: 6002,
        description: {
          pt_br: 'Proprietários por propriedade listados.',
          en_us: 'Land owners retrieved by land successfully.',
        },
      },
      CulturesRetrivedByLandSuccessfully: {
        code: 6003,
        description: {
          pt_br: 'Culturas da propriedade listadas.',
          en_us: 'Cultures retrieved by land successfully.',
        },
      },
      LandFieldEditedSuccessfully: {
        code: 6004,
        description: {
          pt_br: 'Talhão editado.',
          en_us: 'Land field edited successfully',
        },
      },
      LandFieldDeletedSuccessfully: {
        code: 6005,
        description: {
          pt_br: 'Talhão deletado.',
          en_us: 'Land field deleted successfully.',
        },
      },
      LandRegisteredSuccessfully: {
        code: 6006,
        description: {
          pt_br: 'Propriedade cadastrada.',
          en_us: 'Land registered successfully.',
        },
      },
      ShapefilesLandFieldsRegisteredSuccessfully: {
        code: 6007,
        description: {
          pt_br: 'Talhões do shapefile cadastrados.',
          en_us: 'Shapefiles land fields registered successfully.',
        },
      },
      QueryAutoCompleteRetrivedSuccessfully: {
        code: 6008,
        description: {
          pt_br: 'Consulta autocomplete listada.',
          en_us: 'Query auto complete retrieved successfully.',
        },
      },
      PlaceDetailsRetrivedSuccessfully: {
        code: 6009,
        description: {
          pt_br: 'Detalhes do local listados.',
          en_us: 'Place details retrieved successfully.',
        },
      },
    },

    Notification: {
      NotificationCountRetrievedByUserSuccessfully: {
        code: 7000,
        description: {
          pt_br: 'Contagem de notificações recuperada.',
          en_us: 'Notification count retrieved by user successfully.',
        },
      },
      AllNotificationsByUserRetrievedSuccessfully: {
        code: 7001,
        description: {
          pt_br: 'Todas as notificações do usuário foram listadas.',
          en_us: 'All notifications by user retrieved successfully.',
        },
      },
      ChangedAllNotificationsStatusToRead: {
        code: 7002,
        description: {
          pt_br: 'O status de todas as notificações foi alterado para "lido".',
          en_us: 'Changed all notifications status to read.',
        },
      },
      NoNotificationsToChangeStatus: {
        code: 7003,
        description: {
          pt_br: 'Não há notificações para alterar o status.',
          en_us: 'No notifications to change status.',
        },
      },
      PushTokenSentSuccessfully: {
        code: 7004,
        description: {
          pt_br: 'Token de notificação push enviado.',
          en_us: 'Push token sent successfully',
        },
      },
      UserNotificationPreferenceChangedSuccessfully: {
        code: 7005,
        description: {
          pt_br: 'Preferências de notificações modificadas.',
          en_us: 'User notification preference changed successfully.',
        },
      },
      NotificationRegisteredSuccessfully: {
        code: 7006,
        description: {
          pt_br: 'Notificação cadastrada.',
          en_us: 'Notification registered successfully.',
        },
      },
      NotificationEditedSuccessfully: {
        code: 7007,
        description: {
          pt_br: 'Notificação editada.',
          en_us: 'Notification edited successfully.',
        },
      },
      AllNotificationListedSuccessfully: {
        code: 7008,
        description: {
          pt_br: 'Notificações listadas.',
          en_us: 'All notification listed successfully.',
        },
      },
    },

    System: {
      SystemParametersSetSuccessfully: {
        code: 8000,
        description: {
          pt_br: 'Os parâmetros do sistema foram alterados.',
          en_us: 'System parameters set successfully.',
        },
      },
      SystemParametersGotSuccessfully: {
        code: 8001,
        description: {
          pt_br: 'Os parâmetros do sistema foram recuperados.',
          en_us: 'System parameters got successfully.',
        },
      },
      NoTermsAndConditionsSaved: {
        code: 8002,
        description: {
          pt_br: 'Não há termos e condições cadastrados.',
          en_us: 'No terms and conditions saved.',
        },
      },
      TermsAndConditionsGotSuccessfully: {
        code: 8003,
        description: {
          pt_br: 'Os termos e condições foram recuperados.',
          en_us: 'Terms and conditions got successfully.',
        },
      },
      ServicesParametersGotSuccessfully: {
        code: 8004,
        description: {
          pt_br: 'Os parâmetros de serviços foram recuperados.',
          en_us: 'Services parameters got successfully.',
        },
      },
      AttachmentParamentersGotSuccessfully: {
        code: 8005,
        description: {
          pt_br: 'Os parâmetros para anexo de arquivos foram recuperados.',
          en_us: 'Attachment Paramenters Got Successfully.',
        },
      },
      LinkNeedHelpRetrievedSuccessfully: {
        code: 8006,
        description: {
          pt_br: 'Link "Precisa de ajuda" recuperado.',
          en_us: 'link need help retrieved successfully.',
        },
      },
    },

    File: {
      FileUploadedSuccessfully: {
        code: 9000,
        description: {
          pt_br: 'O arquivo foi cadastrado.',
          en_us: 'File uploaded successfully.',
        },
      },
      FileDownloadedSuccessfully: {
        code: 9001,
        description: {
          pt_br: 'O arquivo foi baixado.',
          en_us: 'File downloaded successfully.',
        },
      },
      ServiceRequestFilesUploadedSuccessfully: {
        code: 9002,
        description: {
          pt_br: 'Os arquivos da solicitação de serviço foram cadastrados.',
          en_us: 'Service request files uploaded successfully',
        },
      },
      ServiceRequestFilesEditedSuccessfully: {
        code: 9003,
        description: {
          pt_br: 'Os arquivos da solicitação de serviço foram editados.',
          en_us: 'Service request files edited successfully.',
        },
      },
      ServiceRequestFilesFoundSuccessfully: {
        code: 9004,
        description: {
          pt_br: 'Os arquivos da solicitação de serviço foram encontrados.',
          en_us: 'Service request files found successfully.',
        },
      },
      AllShapefilesGeometriesFoundSuccessfully: {
        code: 9005,
        description: {
          pt_br: 'Os polígonos do shapefile foram encontrados.',
          en_us: 'All shapefiles geometries found successfully.',
        },
      },
      SomeShapefilesGeometriesFoundSuccessfully: {
        code: 9006,
        description: {
          pt_br: 'Alguns polígonos do shapefile foram encontrados.',
          en_us: 'Some shapefiles geometries found successfully.',
        },
      },
      KmlGeometriesFoundSuccessfully: {
        code: 9007,
        description: {
          pt_br: 'Os polígonos do KML foram encontrados.',
          en_us: 'All Kml geometries found successfully.',
        },
      },
      KmzGeometriesFoundSuccessfully: {
        code: 9008,
        description: {
          pt_br: 'Os polígonos do KMZ foram encontrados.',
          en_us: 'All Kmz geometries found successfully.',
        },
      },
      TermsOfAcceptanceFilesEditedSuccessfully: {
        code: 9009,
        description: {
          pt_br: 'Os arquivos de termos de aceite foram editados.',
          en_us: 'Terms of acceptance files edited successfully.',
        },
      },
      TermsOfAcceptanceFilesDeletedSuccessfully: {
        code: 9010,
        description: {
          pt_br: 'Os arquivos de termos de aceite foram deletados.',
          en_us: 'Terms of acceptance files deleted successfully.',
        },
      },
      HistoricTermsAndConditionsFilesFoundSuccessfully: {
        code: 9011,
        description: {
          pt_br: 'O histórico dos arquivos de termos e condições foi recuperado.',
          en_us: 'Historic of terms and conditions files found successfully.',
        },
      },
      TermsOfAcceptanceFoundSuccessfully: {
        code: 9012,
        description: {
          pt_br: 'Os termos de aceite foram encontrados.',
          en_us: 'Terms of acceptance found successfully.',
        },
      },
      BudgetRequestFilesEditedSuccessfully: {
        code: 9013,
        description: {
          pt_br: 'Os arquivos da solicitação de orçamento foram editados.',
          en_us: 'Budget request files edited successfully.',
        },
      },
      ImportOfServiceResultsSuccessfully: {
        code: 9014,
        description: {
          pt_br: 'Os resultados foram importados.',
          en_us: 'Import of service results successfully.',
        },
      },
      ListAllServiceResultsSuccessfully: {
        code: 9015,
        description: {
          pt_br: 'Os resultados de serviços foram listados.',
          en_us: 'List all service results successfully.',
        },
      },
      ExcludeServiceResultsSuccessfully: {
        code: 9016,
        description: {
          pt_br: 'O arquivo de importação de resultados foi excluido.',
          en_us: 'Exclude Service Results Successfully.',
        },
      },
      EditServiceResultsSuccessfully: {
        code: 9017,
        description: {
          pt_br: 'O arquivo de importação de resultados foi editado.',
          en_us: 'Edit Service Results Successfully.',
        },
      },
      ListAllFileResultsCustomerSuccessfully: {
        code: 9018,
        description: {
          pt_br: 'Os arquivos de importação de resultados foram listados ao cooperado.',
          en_us: 'List all file results customer successfully.',
        },
      },
      ListAllFileResultsCoopercitrusSuccessfully: {
        code: 9019,
        description: {
          pt_br: 'Os arquivos de importação de resultados foram listados ao coopercitrus.',
          en_us: 'List all file results coopercitrus successfully.',
        },
      },
    },

    Log: {
      AllLogsListedSuccessfully: {
        code: 10000,
        description: {
          pt_br: 'Os logs foram listados.',
          en_us: 'All logs listed successfully.',
        },
      },
    },

    Voucher: {
      VoucherServicesParametersGotSuccessfully: {
        code: 11000,
        description: {
          pt_br: 'Os parâmetros de serviços do programa de fidelidade foram recuperados.',
          en_us: 'Voucher services parameters got successfully.',
        },
      },
      VoucherServicesParametersSetSuccessfully: {
        code: 11001,
        description: {
          pt_br: 'Os parâmetros de serviços do programa de fidelidade foram editados.',
          en_us: 'Voucher services parameters set successfully.',
        },
      },
    },

    Banner: {
      BannerParametersGotSuccessfully: {
        code: 12000,
        description: {
          pt_br: 'Os parametros do banner foram recuperados.',
          en_us: 'Banner parameters got successfully.',
        },
      },
      BannerParametersGotSuccessfullyNoBannerEnable: {
        code: 12001,
        description: {
          pt_br: 'Os parametros do banner foram recuperados. Visualização não habilitada.',
          en_us: 'Banner parameters got successfully - No display enabled banner.',
        },
      },
      BannerParametersEnabledSuccessfully: {
        code: 12002,
        description: {
          pt_br: 'Os parametros do banner foram habilitados.',
          en_us: 'Banner parameters enabled successfully.',
        },
      },
      BannerParametersDisabledSuccessfully: {
        code: 12003,
        description: {
          pt_br: 'Os parametros do banner foram desabilitados.',
          en_us: 'Banner parameters disabled successfully.',
        },
      },
      BannerParametersSetSuccessfully: {
        code: 12004,
        description: {
          pt_br: 'Os parametros do banner foram alterados.',
          en_us: 'Banner parameters set successfully.',
        },
      },
    },

    Budget: {
      BranchCoopercitrusListedSuccessfully: {
        code: 13000,
        description: {
          pt_br: 'As filiais foram listadas.',
          en_us: 'Branch coopercitrus listed successfully.',
        },
      },
      BudgetRequestedSuccessfully: {
        code: 13001,
        description: {
          pt_br: 'O orçamento foi solicitado.',
          en_us: 'Budget requested successfully.',
        },
      },
      AllBudgetRequestsListedSuccessfully: {
        code: 13002,
        description: {
          pt_br: 'Os orçamentos foram listados.',
          en_us: 'All budget requests listed successfully.',
        },
      },
      MakingTheBudgetAddedSuccessfully: {
        code: 13003,
        description: {
          pt_br: 'A realização do orçamento foi solicitada.',
          en_us: 'Making the budget added successfully.',
        },
      },
      BudgetRecusedSucessFully: {
        code: 13004,
        description: {
          pt_br: 'O orçamento foi recusado.',
          en_us: 'Budget recused got successfully.',
        },
      },
      BudgetApprovedSucessFully: {
        code: 13005,
        description: {
          pt_br: 'O orçamento foi aprovado.',
          en_us: 'Budget approved got successfully.',
        },
      },
      ResponsableUserSetSuccessfully: {
        code: 13006,
        description: {
          pt_br: 'O usuário responsável foi atribuido.',
          en_us: 'Responsable user set successfully.',
        },
      },
      BudgetRequestFoundSuccessfully: {
        code: 13007,
        description: {
          pt_br: 'A solicitação de orçamento foi encontrada.',
          en_us: 'Budget request found successfully.',
        },
      },
      NotesEditedSuccessfully: {
        code: 13008,
        description: {
          pt_br: 'Os comentarios foram editados.',
          en_us: 'Notes edited successfully.',
        },
      },
      NotesSavedSuccessfully: {
        code: 13009,
        description: {
          pt_br: 'Os comentarios foram salvos.',
          en_us: 'Notes saved successfully.',
        },
      },
      NotesDeletedSuccessfully: {
        code: 13010,
        description: {
          pt_br: 'Os comentarios foram deletados.',
          en_us: 'Notes deleted successfully.',
        },
      },
      BudgetRequestEditedSuccessfully: {
        code: 13011,
        description: {
          pt_br: 'A solicitação de orçamento foi editada.',
          en_us: 'Budget request edited successfully.',
        },
      },
      BudgetFlowListedSuccessfully: {
        code: 13012,
        description: {
          pt_br: 'O fluxo do orçamento foi listado.',
          en_us: 'Budget flow listed successfully',
        },
      },
      BranchGuestUserListedSuccessfully: {
        code: 13013,
        description: {
          pt_br: 'As filiais foram listadas ao convidado.',
          en_us: 'Branch guest user listed successfully.',
        },
      },
    },

    EquipamentModel: {
      EquipamentModelRegisteredSuccessfully: {
        code: 14000,
        description: {
          pt_br: 'O modelo de equipamento foi registrado.',
          en_us: 'Equipament model registered successfully.',
        },
      },
      EquipamentModelListedSuccessfully: {
        code: 14001,
        description: {
          pt_br: 'Os modelos de equipamento foram listados.',
          en_us: 'Equipament model listed successfully.',
        },
      },
      EquipamentModelDeletedSuccessfully: {
        code: 14002,
        description: {
          pt_br: 'O modelo de equipamento foi deletado.',
          en_us: 'Equipament model deleted successfully.',
        },
      },
      EquipamentModelEditedSuccessfully: {
        code: 14003,
        description: {
          pt_br: 'O modelo de equipamento foi editado.',
          en_us: 'Equipament model edited successfully.',
        },
      },
      EquipamentModelFoundSuccessfully: {
        code: 14004,
        description: {
          pt_br: 'O modelo de equipamento foi encontrado.',
          en_us: 'Equipament model found successfully.',
        },
      },
    },

    Event: {
      EventRequestSuccessfully: {
        code: 15000,
        description: {
          pt_br: 'O evento foi cadastrado.',
          en_us: 'Event request successfully.',
        },
      },
      EventCanceledSuccessfully: {
        code: 15001,
        description: {
          pt_br: 'O evento foi cancelado.',
          en_us: 'Event canceled successfully.',
        },
      },
      EventEditedSuccessfully: {
        code: 15002,
        description: {
          pt_br: 'O evento foi editado.',
          en_us: 'Event edited successfully.',
        },
      },
      AllEventFilterListedSuccessfully: {
        code: 15003,
        description: {
          pt_br: 'A listagem de eventos foi filtrada.',
          en_us: 'All event filter listed successfully.',
        },
      },
      EventDayListedSuccessfully: {
        code: 15004,
        description: {
          pt_br: 'Os dias de evento foram listados.',
          en_us: 'Event day listed successfully.',
        },
      },
      EventListedSuccessfully: {
        code: 15005,
        description: {
          pt_br: 'O evento foi recuperado.',
          en_us: 'Event listed successfully',
        },
      },
    },

    Branch: {
      Generic: {
        code: 1,
        description: {
          pt_br: 'A requisição foi completada com sucesso.',
          en_us: 'The request was completed successfully.',
        },
      },
      BranchRequestSuccessfully: {
        code: 16000,
        description: {
          pt_br: 'A filial foi cadastrada.',
          en_us: 'Branch request successfully.',
        },
      },
      BranchEditedSuccessfully: {
        code: 16001,
        description: {
          pt_br: 'A filial foi editada.',
          en_us: 'Branch edited Successfully.',
        },
      },
      BranchDeletedSuccessfully: {
        code: 16002,
        description: {
          pt_br: 'A filial foi deletada.',
          en_us: 'Branch deleted successfully.',
        },
      },
      BranchListedSuccessfully: {
        code: 16003,
        description: {
          pt_br: 'As filiais foram listadas.',
          en_us: 'Branch listed successfully.',
        },
      },
      BranchCreatedSuccessfully: {
        code: 16000,
        description: {
          pt_br: 'Filial cadastrada com sucesso.',
          en_us: 'Branch created Successfully.',
        },
      },
      FindByBranch: {
        code: 16003,
        description: {
          pt_br: 'A filial foi carregada com sucesso.',
          en_us: 'The request was completed successfully.',
        },
      },
      UploadImageSuccessfully: {
        code: 9020,
        description: {
          pt_br: 'As imagens foram anexadas com sucesso.',
          en_us: 'The images have been successfully attached.',
        },
      },
    },

    Bp: {
      BpValidatedSuccessfully: {
        code: 17000,
        description: {
          pt_br: 'O BP foi validado.',
          en_us: 'BP validated successfully.',
        },
      },
    },

    NotificationCategory: {
      NotificationCategoryRequestSuccessfully: {
        code: 18000,
        description: {
          pt_br: '',
          en_us: 'Notification category request successfully.',
        },
      },
      NotificationCategoryEditedSuccessfully: {
        code: 18001,
        description: {
          pt_br: '',
          en_us: 'Notification category edited successfully.',
        },
      },
      NotificationCategoryListedSuccessfully: {
        code: 18002,
        description: {
          pt_br: '',
          en_us: 'Notification category listed successfully',
        },
      },
    },

    WordPressApi: {
      WordpressApiPostListedSuccessfully: {
        code: 19000,
        description: {
          pt_br: 'O post da API do Wordpress foi listado.',
          en_us: 'Wordpress api post listed successfully.',
        },
      },
      WordpressApiPostDetailsListedSuccessfully: {
        code: 19001,
        description: {
          pt_br: 'Os detalhes do post da API do Wordpress foram listados.',
          en_us: 'Wordpress api post details listed successfully.',
        },
      },
      WordpressApiReleaseListedSuccessfully: {
        code: 19002,
        description: {
          pt_br: 'A release da API do Wordpress foi listada.',
          en_us: 'Wordpress api release listed successfully.',
        },
      },
      WordpressApiReleaseDetailsListedSuccessfully: {
        code: 19003,
        description: {
          pt_br: 'Os detalhes da release da API do Wordpress foram listados.',
          en_us: 'Wordpress api release details listed successfully.',
        },
      },
      WordpressApiClassifiedListedSuccessfully: {
        code: 19004,
        description: {
          pt_br: 'Os classificados da API do Wordpress foram listados.',
          en_us: 'Wordpress api classified listed successfully.',
        },
      },
      WordpressApiClassifiedDetailsListedSuccessfully: {
        code: 19005,
        description: {
          pt_br: 'Os detalhes dos classificados da API Wordpress foram listados.',
          en_us: 'Wordpress api classified details listed successfully.',
        },
      },
      WordpressApiEventListedSuccessfully: {
        code: 19006,
        description: {
          pt_br: 'Os eventos da API do Wordpress foram listados.',
          en_us: 'Wordpress api event successfully.',
        },
      },
      WordpressApiEventDetailsListedSuccessfully: {
        code: 19007,
        description: {
          pt_br: 'Os detalhes dos eventos da API do Wordpress foram listados.',
          en_us: 'Wordpress api event details listed successfully.',
        },
      },
      WordpressApiPodcastListedSuccessfully: {
        code: 19008,
        description: {
          pt_br: 'Os podcasts da API do Wordpress foram listados.',
          en_us: 'Wordpress api podcast successfully.',
        },
      },
      WordpressApiPodcastDetailsListedSuccessfully: {
        code: 19009,
        description: {
          pt_br: 'Os detalhes dos podcasts da API do Wordpress foram listados',
          en_us: 'Wordpress api podcast details listed successfully.',
        },
      },
      WordpressApiMagazineListedSuccessfully: {
        code: 19010,
        description: {
          pt_br: 'As revistas da API do Wordpress foram listadas.',
          en_us: 'Wordpress api magazine successfully.',
        },
      },
      WordpressApiMagazineDetailsListedSuccessfully: {
        code: 19011,
        description: {
          pt_br: 'Os detalhes das revistas da API do Wordpress foram listados.',
          en_us: 'Wordpress api magazine details listed successfully.',
        },
      },
    },
  },

  Error: {
    ExampleDoNotUse: {
      ExampleErrorNameInBackend: {
        code: 0,
        description: {
          pt_br: '',
          en_us: '',
        },
      },
    },

    User: {
      EmailAlreadyInUse: {
        code: -1000,
        description: {
          pt_br: 'Email já utilizado em outra conta.',
          en_us: 'Email already in use.',
        },
      },
      InvalidEmailOrPassword: {
        code: -1001,
        description: {
          pt_br: 'E-mail e/ou senha inválidos. Verifique e tente novamente',
          en_us: 'Invalid email or password.',
        },
      },
      EmailNotConfirmed: {
        code: -1002,
        description: {
          pt_br: 'E-mail ainda não confirmado.',
          en_us: 'Email not confirmed.',
        },
      },
      UserIsNotLoggedIn: {
        code: -1003,
        description: {
          pt_br: 'Você deve estar logado para realizar esta ação.',
          en_us: 'User should be logged in to perform this operation.',
        },
      },
      EmailTokenNotFound: {
        code: -1004,
        description: {
          pt_br: 'Token de email não encontrado.',
          en_us: 'Email token not found.',
        },
      },
      InvalidEmailToken: {
        code: -1005,
        description: {
          pt_br: 'Token de email inválido.',
          en_us: 'Invalid email token.',
        },
      },
      InvalidOldPassword: {
        code: -1006,
        description: {
          pt_br: 'Senha incorreta. Digite a senha antiga corretamente para poder cadastrar uma nova senha.',
          en_us: 'Invalid old password.',
        },
      },
      UserNotFound: {
        code: -1007,
        description: {
          pt_br: 'Usuário não encontrado.',
          en_us: 'User not found.',
        },
      },
      UserCannotUseThisStatus: {
        code: -1008,
        description: {
          pt_br: 'O usuário não pode utilizar o status informado.',
          en_us: 'User cannot use this status.',
        },
      },
      PasswordResetTokenNotFound: {
        code: -1009,
        description: {
          pt_br: 'Token de redefinição de senha não encontrado.',
          en_us: 'Password reset token not found.',
        },
      },
      InvalidListAllUsersFilters: {
        code: -1010,
        description: {
          pt_br: 'Filtros inválidos para a listagem de usuários.',
          en_us: 'Invalid list all users filters.',
        },
      },
      UserCannotDeleteItself: {
        code: -1011,
        description: {
          pt_br: 'Não é permitido excluir o próprio usuário logado.',
          en_us: 'User cannot delete itself.',
        },
      },
      CustomerNotActivated: {
        code: -1012,
        description: {
          pt_br: 'Usuário inativo. Entre em contato com a sua filial.',
          en_us: 'Customer not activated.',
        },
      },
      AdminNotActivated: {
        code: -1013,
        description: {
          pt_br: 'Usuário inativo. Entre em contato com o administrador do sistema.',
          en_us: 'Admin not activated.',
        },
      },
      CustomerWithConfirmedEmail: {
        code: -1014,
        description: {
          pt_br: 'Este email já está confirmado.',
          en_us: 'Customer with confirmed email.',
        },
      },
      CurrentDocumentPendingAcceptance: {
        code: -1015,
        description: {
          pt_br: 'Documentos pendentes de aceitação.',
          en_us: 'Current document pending acceptance.',
        },
      },
      InvalidFederalRegistrationOrPassword: {
        code: -1016,
        description: {
          pt_br: 'Autenticação inválida! Os dados informados estão incorretos.',
          en_us: 'Invalid federal registration or password.',
        },
      },
      EmptyEmailFieldInSapBase: {
        code: -1017,
        description: {
          pt_br: 'Campo email vazio no SAP.',
          en_us: 'Empty email field in sap base.',
        },
      },
      EmptyTelephoneFieldInSapBase: {
        code: -1018,
        description: {
          pt_br: 'Campo telefone vazio no SAP.',
          en_us: 'Empty telephone field in sap base.',
        },
      },
      FederalRegistrationAlreadyLinkedToAnotherUser: {
        code: -1019,
        description: {
          pt_br: 'Número de registro vinculado a outro usuário.',
          en_us: 'Federal registration already linked to another user.',
        },
      },
      FederalRegistrationNotActivated: {
        code: -1020,
        description: {
          pt_br: 'O CPF/CNPJ informado está vinculado a um usuário inativo. Procure a filial Coopercitrus mais próxima.',
          en_us: 'Federal registration not activated.',
        },
      },
      FederalRegistrationNotFoundInSapDatabase: {
        code: -1021,
        description: {
          pt_br: 'CPF/CNPJ não encontrado.',
          en_us: 'Federal registration not found in sap database.',
        },
      },
      EmailAndTelephoneNotFoundInSapDatabase: {
        code: -1022,
        description: {
          pt_br: 'Campo e-mail e telefone vazio, procure a filial mais próxima para atualizar os seus dados cadastrais.',
          en_us: 'Email and telephone not found in sap database.',
        },
      },
      InvalidToken: {
        code: -1023,
        description: {
          pt_br: 'Token inválido. O token enviado não está correto. Verifique e tente novamente.',
          en_us: 'Invalid token.',
        },
      },
      ExpiredToken: {
        code: -1024,
        description: {
          pt_br: 'Token expirado.',
          en_us: 'Expired token.',
        },
      },
      TokenNotValidated: {
        code: -1025,
        description: {
          pt_br: 'Token pendente de validação.',
          en_us: 'Token not validated.',
        },
      },
      TokenCannotBeNull: {
        code: -1026,
        description: {
          pt_br: 'Token inválido.',
          en_us: 'Token cannot be null.',
        },
      },
      FederalRegistrationIsNotValid: {
        code: -1027,
        description: {
          pt_br: 'CPF/CNPJ inválido.',
          en_us: 'Federal registration is not valid.',
        },
      },
      CooperatedFederalRegistrationOnly: {
        code: -1028,
        description: {
          pt_br: 'Para Cooperado deve ser informado o CPF/CNPJ.',
          en_us: 'For Cooperated the federal registration must be informed.',
        },
         
      },
      AccessDeniedTheApplicationForUser:{
        code: -1029,
        description: {
          pt_br: 'O acesso ao aplicativo é permitido somente para cooperados, funcionários e estagiários.',
          en_us: 'Access to the application is only allowed for cooperative members, employees and interns.',
        },
         
      }
    },

    Matriculation: {
      MatriculationCannotBeNull: {
        code: -2000,
        description: {
          pt_br: 'Matrícula não pode ser nula.',
          en_us: 'Matriculation cannot be null.',
        },
      },
      ThereAreNoValidMatriculations: {
        code: -2005,
        description: {
          pt_br: 'Não há matrículas ativas.',
          en_us: 'There are no valid matriculations.',
        },
      },
      DuplicatedMatriculations: {
        code: -2001,
        description: {
          pt_br: 'Matrículas duplicadas.',
          en_us: 'Duplicated matriculations.',
        },
      },
      MatriculationNotFound: {
        code: -2002,
        description: {
          pt_br: 'A matrícula não foi encontrada.',
          en_us: 'Matriculation not found.',
        },
      },
      AnActivatedMatriculationFromCustomerShouldBeInformed: {
        code: -2003,
        description: {
          pt_br: 'Uma matricula aprovada do cooperado deve ser informada.',
          en_us: 'An activated matriculation from customer should be informed.',
        },
      },
      CustomerMustHaveAtLeastOneMatriculation: {
        code: -2004,
        description: {
          pt_br: 'O cooperado deve ter ao menos uma matrícula.',
          en_us: 'Customer must have at least one matriculation.',
        },
      },
    },

    Role: {
      RoleNotFound: {
        code: -3000,
        description: {
          pt_br: 'Perfil não encontrado.',
          en_us: 'Role not found.',
        },
      },

      UserCannotUseThisRole: {
        code: -3001,
        description: {
          pt_br: 'O usuário não pode utilizar este perfil.',
          en_us: 'User cannot use this role.',
        },
      },

      UserCannotEditOwnRole: {
        code: -3002,
        description: {
          pt_br: 'Não é permitido editar o próprio perfil.',
          en_us: 'User cannot edit own role.',
        },
      },

      AtLeastOneAdminShouldBeOnSystem: {
        code: -3003,
        description: {
          pt_br: 'Deve existir ao menos um administrador no sistema.',
          en_us: 'At least one admin should be on system.',
        },
      },

      RoleTypeCannotBeChanged: {
        code: -3004,
        description: {
          pt_br: 'O tipo do perfil não pode ser modificado.',
          en_us: 'Role type cannot be changed.',
        },
      },

      RoleNameAlreadyInUse: {
        code: -3005,
        description: {
          pt_br: 'O nome do perfil já está em uso.',
          en_us: 'Role name already in use.',
        },
      },

      ADeactivatedRoleCannotBeDefault: {
        code: -3006,
        description: {
          pt_br: 'Um perfil inativo não pode ser padrão.',
          en_us: 'A deactivated role cannot be default.',
        },
      },

      InvalidPermissions: {
        code: -3007,
        description: {
          pt_br: 'Permissões inválidas.',
          en_us: 'Invalid permissions.',
        },
      },

      CannotEditSystemAdminRole: {
        code: -3008,
        description: {
          pt_br: 'Não é permitido editar o perfil de administrador do sistema.',
          en_us: 'Cannot edit system admin role.',
        },
      },

      CannotDeleteRoleUsedAtLeastByOneUser: {
        code: -3009,
        description: {
          pt_br: 'Não é permitido excluir um perfil em uso.',
          en_us: 'Cannot delete role used at least by one user.',
        },
      },

      DefaultRoleFlagCannotBeRemoved: {
        code: -3010,
        description: {
          pt_br: 'Não é permitido remover a marcação de perfil padrão.',
          en_us: 'Default role flag cannot be removed.',
        },
      },

      CannotDeleteDefaultRole: {
        code: -3011,
        description: {
          pt_br: 'Não é permitido excluir um perfil padrão.',
          en_us: 'Cannot delete default role.',
        },
      },

      CannotDeleteSystemAdminRole: {
        code: -3012,
        description: {
          pt_br: 'Não é permitido excluir o perfil de Administrador do Sistema.',
          en_us: 'Cannot delete system admin role.',
        },
      },

      CannotRemoveUsersFromDefaultRole: {
        code: -3013,
        description: {
          pt_br: 'Não é permitido excluir usuários de um perfil padrão.',
          en_us: 'Cannot remove users from default role.',
        },
      },

      LoggedUserCannotAddYourselfToAnotherRole: {
        code: -3014,
        description: {
          pt_br: 'Não é permitido atribuir outro perfil a si mesmo.',
          en_us: 'Logged user cannot add yourself to another role.',
        },
      },

      LoggedUserCannotRemoveYourRole: {
        code: -3015,
        description: {
          pt_br: 'Não é permitido excluir o próprio perfil.',
          en_us: 'Logged user cannot remove your role.',
        },
      },

      SomeUsersCannotBeAddedToTheRole: {
        code: -3016,
        description: {
          pt_br: 'Alguns usuários não podem ser adicionados ao perfil.',
          en_us: 'Some users cannot be added to the role.',
        },
      },

      SomeUsersCannotBeRemovedFromTheRole: {
        code: -3017,
        description: {
          pt_br: 'Alguns usuários não podem ser removidos do perfil.',
          en_us: 'Some users cannot be removed from the role.',
        },
      },

      RoleAlreadyDefault: {
        code: -3018,
        description: {
          pt_br: 'O perfil ja é padrão.',
          en_us: 'Role already default.',
        },
      },
    },

    General: {
      SomethingUnexpectedHappened: {
        code: -4000,
        description: {
          pt_br: 'Desculpe, houve um erro ao executar esta ação, por favor tente novamente mais tarde.',
          en_us: 'Something unexpected happened',
        },
      },
      Unauthorized: {
        code: -4001,
        description: {
          pt_br: 'Login expirado. Por favor, entre novamente.',
          en_us: 'You must be authenticated to perform this operation',
        },
      },
      Forbidden: {
        code: -4003,
        description: {
          pt_br: 'Desculpe, você não possui permissão para executar esta ação.',
          en_us: 'You do not have permission to perform this operation',
        },
      },
    },

    Service: {
      ServiceNotFound: {
        code: -5000,
        description: {
          pt_br: 'O Serviço não foi encontrado.',
          en_us: 'Service not found.',
        },
      },
      ServiceTypeNotFound: {
        code: -5001,
        description: {
          pt_br: 'O Tipo de Serviço não foi encontrado.',
          en_us: 'Service type not found.',
        },
      },
      ServiceTypeDontMatchWithService: {
        code: -5002,
        description: {
          pt_br: 'O Tipo de Serviço não tem relação com o Serviço.',
          en_us: 'Service type dont match with service.',
        },
      },
      ServiceSubtypeNotFound: {
        code: -5003,
        description: {
          pt_br: 'O SubTipo de Serviço não foi encontrado.',
          en_us: 'Service subtype not found.',
        },
      },
      ServiceSubtypeDoNotMatchWithServiceType: {
        code: -5004,
        description: {
          pt_br: 'O SubTipo de Serviço não tem relação com o Tipo de Serviço.',
          en_us: 'Service subtype do not match with service type.',
        },
      },
      InvalidServiceSubtypeDynamicFields: {
        code: -5005,
        description: {
          pt_br: 'Os campos dinâmicos de subtipo de serviço informados são inválidos.',
          en_us: 'Invalid service subtype dynamic fields.',
        },
      },
      InvalidServiceTypeDynamicFields: {
        code: -5006,
        description: {
          pt_br: 'Os campos dinâmicos de tipo de serviço informados são inválidos.',
          en_us: 'Invalid service type dynamic fields.',
        },
      },
      UserAdminMustSendAMatriculation: {
        code: -5007,
        description: {
          pt_br: 'O administrador deve informar uma matrícula.',
          en_us: 'User Admin must send a matriculation.',
        },
      },
      ServiceRequestNotFound: {
        code: -5008,
        description: {
          pt_br: 'A solicitação de serviço não foi encontrada.',
          en_us: 'Service request not found.',
        },
      },
      MissingScheduleDate: {
        code: -5009,
        description: {
          pt_br: 'A data de agendamento é obrigatória.',
          en_us: 'Missing mandatory scheduled date.',
        },
      },
      IsServiceRequestLastStep: {
        code: -5010,
        description: {
          pt_br: 'O serviço está em seu último passo.',
          en_us: 'Is service request last step.',
        },
      },
      PastDateEntered: {
        code: -5011,
        description: {
          pt_br: 'Não é permitido informar uma data no passado.',
          en_us: 'Past date entered.',
        },
      },
      CannotUpdateCancelledServiceRequest: {
        code: -5012,
        description: {
          pt_br: 'Não é permitido atualizar uma solicitação de serviço cancelada.',
          en_us: 'Cannot update cancelled service request.',
        },
      },
      InvalidListServiceRequestsFilters: {
        code: -5013,
        description: {
          pt_br: 'Combinação inválida de filtros de listagem de serviços.',
          en_us: 'Invalid list service requests filters.',
        },
      },
      ServiceRequestStepDynamicFieldNotFound: {
        code: -5014,
        description: {
          pt_br: 'Alguns campos não foram informados.',
          en_us: 'Service request step dynamic field not found.',
        },
      },
      InvalidReasonForCancellation: {
        code: -5015,
        description: {
          pt_br: 'O motivo de cancelamento informado é inválido.',
          en_us: 'Invalid reason for cancellation.',
        },
      },
      CannotAttachFilesToServiceRequestNotConcluded: {
        code: -5016,
        description: {
          pt_br: 'Não é permitido anexar arquivos a uma solicitação de serviços não concluida.',
          en_us: 'Cannot attach files to service request not concluded.',
        },
      },
      MinQuantityOfUnreachedHectare: {
        code: -5017,
        description: {
          pt_br: 'A solicitação de serviços não atingiu a quantidade mínima de hectares.',
          en_us: 'Min quantity of unreached hectare.',
        },
      },
      NextStepNotFound: {
        code: -5019,
        description: {
          pt_br: 'O Próximo passo no fluxo de serviços não foi encontrado.',
          en_us: 'Next step not found.',
        },
      },
      DoesNotHaveAWeedMap: {
        code: -5020,
        description: {
          pt_br: 'Não é permitido solicitar este serviço sem o mapa de ervas daninhas.',
          en_us: 'Service has no weed map.',
        },
      },
      TelephoneSizeTooLarge: {
        code: -5021,
        description: {
          pt_br: 'O telefone informado é invalido pois contem mais caracteres do que o permitido.',
          en_us: 'Telephone size is too large.',
        },
      },
      TelephoneSizeTooSmall: {
        code: -5022,
        description: {
          pt_br: 'O telefone informado é inválido pois contém menos caracteres do que o permitido.',
          en_us: 'Telephone size is too small.',
        },
      },
      TelephoneCanNotBeNull: {
        code: -5023,
        description: {
          pt_br: 'O telefone não pode ser vazio.',
          en_us: 'Telephone can not be null.',
        },
      },
      CooperCitrusNotesTooLarge: {
        code: -5024,
        description: {
          pt_br: 'O campo observações do coopercitrus é muito extenso.',
          en_us: 'Coopercitrus notes too large.',
        },
      },
      NotesNotFound: {
        code: -5025,
        description: {
          pt_br: 'As observações não foram encontradas.',
          en_us: 'Notes not found.',
        },
      },
      NotesDontBelongToServiceRequest: {
        code: -5026,
        description: {
          pt_br: 'As observações informadas não pertencem a solicitação de serviços informada.',
          en_us: 'Notes don\'t belong to service request.',
        },
      },
      ServiceSubtypeNoWeedMap: {
        code: -5027,
        description: {
          pt_br: 'Não é permitido solicitar este serviço sem o mapa de ervas daninhas.',
          en_us: 'Without weed map you cannot continue.',
        },
      },
      CooperativeNotesTooLarge: {
        code: -5028,
        description: {
          pt_br: 'As observações do cooperado são muito extensas.',
          en_us: 'Cooperative notes too large.',
        },
      },
      ProblemsWithDepthsValues: {
        code: -5029,
        description: {
          pt_br: 'Os campos de profundidade informados são inválidos.',
          en_us: 'Problems with depths values.',
        },
      },
      mandatoryFillCtc: {
        code: -5030,
        description: {
          pt_br: 'O campo ctc é obrigatório',
          en_us: 'mandatory fill ctc.',
        },
      },
      requiredBranch: {
        code: -5031,
        description: {
          pt_br: 'O campo filial/unidade de negócios é obrigatório',
          en_us: 'required branch.',
        },
      },
      TechnicianNotFound: {
        code: -5032,
        description: {
          pt_br: 'Usuário Técnico não encontrado.',
          en_us: 'Technician not found.',
        },
      },
      ResponsibleUserCannotBeNull: {
        code: -5033,
        description: {
          pt_br: 'O usuário responsável não pode ser vazio.',
          en_us: 'Responsible user cannot be null.',
        },
      },
      MandatoryRefusalReason: {
        code: -5034,
        description: {
          pt_br: 'O motivo de recusa é obrigatório.',
          en_us: 'Mandatory refusal reason.',
        },
      },
      BudgetValuesInTheMandatoryServiceRequest: {
        code: -5035,
        description: {
          pt_br: 'Existem campos não informados.',
          en_us: 'Budget values in the mandatory service request.',
        },
      },
    },

    Land: {
      UserCannotCreateLandFieldOnThisLand: {
        code: -6000,
        description: {
          pt_br: 'O usuário não pode criar um talhão nesta propriedade.',
          en_us: 'User cannot create land field on this land.',
        },
      },
      ALandFieldShouldBeASimplePolygon: {
        code: -6001,
        description: {
          pt_br: 'O talhão deve ser um poligono simples.',
          en_us: 'A land field should be a simple polygon.',
        },
      },
      LandNotFound: {
        code: -6002,
        description: {
          pt_br: 'A propriedade não foi encontrada.',
          en_us: 'Land not found.',
        },
      },
      LandFieldShouldBeAValidPolygon: {
        code: -6003,
        description: {
          pt_br: 'O talhão deve ser um polígono válido.',
          en_us: 'A land field should be a valid polygon.',
        },
      },
      LandFieldIsNotFromInformedLand: {
        code: -6004,
        description: {
          pt_br: 'O talhão não pertence a propriedade informada.',
          en_us: 'Land field is not from informed land.',
        },
      },
      CultureNotFound: {
        code: -6005,
        description: {
          pt_br: 'Cultura não encontrada.',
          en_us: 'Culture not found.',
        },
      },
      ThisCultureIsNotValidForThisService: {
        code: -6006,
        description: {
          pt_br: 'Esta cultura não é valida para este serviço.',
          en_us: 'This culture is not valid for this service.',
        },
      },
      LandOwnerNotFound: {
        code: -6007,
        description: {
          pt_br: 'Proprietário não encontrado.',
          en_us: 'Land owner not found.',
        },
      },
      LandOwnerDoNotMatchesWithLand: {
        code: -6008,
        description: {
          pt_br: 'O proprietário e a propriedade não estão associados.',
          en_us: 'Land owner do not matches with land.',
        },
      },
      LandOwnerIsNotFromAnActivatedMatriculation: {
        code: -6009,
        description: {
          pt_br: 'O proprietário não pertence a uma matricula aprovada.',
          en_us: 'Land owner is not from an activated matriculation.',
        },
      },
      AValidLandFieldShouldBeInformed: {
        code: -6010,
        description: {
          pt_br: 'Um talhão válido deve ser informado.',
          en_us: 'A valid land field should be informed.',
        },
      },
      ThisCultureIsNotValidForThisLand: {
        code: -6011,
        description: {
          pt_br: 'Esta cultura não é valida para esta propriedade.',
          en_us: 'This culture is not valid for this land.',
        },
      },
      UserCannotEditLandFieldOnThisLand: {
        code: -6012,
        description: {
          pt_br: 'O usuário não pode editar um talhão nesta propriedade.',
          en_us: 'User cannot edit land field on this land.',
        },
      },
      UserCannotDeleteLandFieldOnThisLand: {
        code: -6013,
        description: {
          pt_br: 'O usuário não pode excluir um talhão nesta propriedade.',
          en_us: 'User cannot delete land field on this land.',
        },
      },
      LandFieldNotFound: {
        code: -6014,
        description: {
          pt_br: 'Talhão não encontrado.',
          en_us: 'Land field not found.',
        },
      },
      AValidLandOwnerShouldBeInformed: {
        code: -6015,
        description: {
          pt_br: 'Um proprietário válido deve ser informado.',
          en_us: 'A valid land owner should be informed.',
        },
      },
      InvalidLandFieldArea: {
        code: -6016,
        description: {
          pt_br: 'A área do talhão não corresponde aos seus pontos geográficos.',
          en_us: 'The land field area does not correspond to land field points area.',
        },
      },
      LandsWithDifferentCultures: {
        code: -6017,
        description: {
          pt_br: 'Não é permitido que os talhões selecionados contenham culturas diferentes.',
          en_us: 'Land with different cultures.',
        },
      },
      LandFieldCanNotBeExcluded: {
        code: -6018,
        description: {
          pt_br: 'O talhão não pode ser excluído.',
          en_us: 'Land field can not be excluded.',
        },
      },
    },

    Notification: {
      TargetUserHasNoNotificationTokenRegistered: {
        code: -7000,
        description: {
          pt_br: 'O usuário não tem um token de notificação registrado.',
          en_us: 'Target user has no notification token registered.',
        },
      },
      NotificationNotFound: {
        code: -7001,
        description: {
          pt_br: 'Notificação não encontrada.',
          en_us: 'Notification not found.',
        },
      },
      notificationCannotBeEdited: {
        code: -7002,
        description: {
          pt_br: 'A notificação não pode ser editada.',
          en_us: 'Notification cannot be edited.',
        },
      },
    },

    System: {
      ServiceNotFound: {
        code: -8000,
        description: {
          pt_br: 'O serviço não foi encontrado.',
          en_us: 'Service not found.',
        },
      },
      FinancialMaxPeriodOfDaysIsLessThanZero: {
        code: -8001,
        description: {
          pt_br: 'O período máximo de dias do financeiro deve ser maior que zero.',
          en_us: 'Maximum financial period of days is less than zero.',
        },
      },
      TermsAndConditionsOfUseCannotBeNull: {
        code: -8002,
        description: {
          pt_br: 'Os termos e condições de uso não podem ser vazios.',
          en_us: 'Terms and conditions of use cannot be null.',
        },
      },
      NeedToUpdateTheApp: {
        code: -8003,
        description: {
          pt_br: 'É necessário atualizar o aplicativo.',
          en_us: 'Need to update the app.',
        },
      },
    },

    File: {
      FileTooLarge: {
        code: -9000,
        description: {
          pt_br: 'O arquivo excede o tamanho limite.',
          en_us: 'File too large.',
        },
      },
      FileTypeNotSupported: {
        code: -9001,
        description: {
          pt_br: 'O tipo de arquivo não é suportado.',
          en_us: 'File type not supported.',
        },
      },
      FileNotFound: {
        code: -9002,
        description: {
          pt_br: 'O arquivo não foi encontrado.',
          en_us: 'File not found.',
        },
      },
      TermsAndConditionsMustNotBeLinkedToServiceRequest: {
        code: -9003,
        description: {
          pt_br: 'O arquivo de termos e condições não pode estar vinculado a uma solicitação de serviços.',
          en_us: 'Terms and conditions must not be linked to service request.',
        },
      },
      AllFilesExceedsTheLimitSize: {
        code: -9004,
        description: {
          pt_br: 'A soma do tamanho dos arquivos excede o limite.',
          en_us: 'All files exceeds the limit size.',
        },
      },
      ServiceRequestHasAttachedFiles: {
        code: -9005,
        description: {
          pt_br: 'A solicitação de serviços conteém arquivos anexados.',
          en_us: 'Service request has attached files.',
        },
      },
      ServiceRequestFilesNotFound: {
        code: -9006,
        description: {
          pt_br: 'Os arquivos da solicitação de serviços não foram encontrados.',
          en_us: 'Service request files not found.',
        },
      },
      FileIsNotRelatedToCustomerMatriculations: {
        code: -9007,
        description: {
          pt_br: 'O arquivo não está relacionado às matriculas do cooperado.',
          en_us: 'File is not related to customer matriculations.',
        },
      },
      ShapefileNotFound: {
        code: -9008,
        description: {
          pt_br: 'O arquivo Shapefile não foi encontrado.',
          en_us: 'Shapefile not found.',
        },
      },
      ShapefileCouldNotBeGenerated: {
        code: -9009,
        description: {
          pt_br: 'O arquivo Shapefile não pode ser gerado.',
          en_us: 'Shapefile could not be generated.',
        },
      },
      ShapefilesGeometriesNotFound: {
        code: -9010,
        description: {
          pt_br: 'Os polígonos do arquivo Shapefile não foram encontrado.s',
          en_us: 'Shapefiles geometries not found.',
        },
      },
      KmlNotFound: {
        code: -9011,
        description: {
          pt_br: 'O arquivo KML não foi encontrado.',
          en_us: 'Kml not found.',
        },
      },
      KmlCouldNotBeGenerated: {
        code: -9012,
        description: {
          pt_br: 'O arquivo KML não pode ser gerado.',
          en_us: 'Kml could not be generated.',
        },
      },
      KmzNotFound: {
        code: -9013,
        description: {
          pt_br: 'O arquivo KMZ não foi encontrado.',
          en_us: 'Kmz not found.',
        },
      },
      KmzCouldNotBeGenerated: {
        code: -9014,
        description: {
          pt_br: 'O arquivo KMZ não pode ser gerado',
          en_us: 'Kmz could not be generated.',
        },
      },
      TermsOfAcceptanceNameTooLarge: {
        code: -9015,
        description: {
          pt_br: 'O nome dos termos de aceite é muito extenso.',
          en_us: 'Terms of acceptance name too large.',
        },
      },
      LinkToHelpCannotBeEmpty: {
        code: -9016,
        description: {
          pt_br: 'O link para ajuda não pode ser vazio.',
          en_us: 'The link to help cannot be empty.',
        },
      },
      TermsOfAcceptanceListIsEmpty: {
        code: -9017,
        description: {
          pt_br: 'A lista de termos de aceite está vazia.',
          en_us: 'Terms of acceptance list is empty.',
        },
      },
      FileIsNotTermsOfAcceptance: {
        code: -9018,
        description: {
          pt_br: 'O arquivo não é do tipo termo de aceite.',
          en_us: 'File is not terms of acceptance.',
        },
      },
      InvalidFileImportResultFilters: {
        code: -9019,
        description: {
          pt_br: 'Os filtros informados para a listagem de resultados são inválidos.',
          en_us: 'Invalid file import result filters.',
        },
      },
    },

    Log: {
      InvalidListLogsFilters: {
        code: -10000,
        description: {
          pt_br: 'Os filtros informados para a listagem de logs são inválidos.',
          en_us: 'Invalid list logs filters.',
        },
      },
    },

    Voucher: {
      CostByHectareNegativeIsNotAllowed: {
        code: -11000,
        description: {
          pt_br: 'Não é permitido informar um custo por hectare negativo.',
          en_us: 'Cost by hectare negative is not allowed.',
        },
      },
    },

    Banner: {
      BannerParametersNotFound: {
        code: -12000,
        description: {
          pt_br: 'Os parâmetros do banner não foram encontrados.',
          en_us: 'Banner parameters not found.',
        },
      },
      linkParameterCannotBeNull: {
        code: -12001,
        description: {
          pt_br: 'O parâmetro link não pode ser vazio.',
          en_us: 'link parameter cannot be null.',
        },
      },
    },

    ImportKmlKmz: {
      KmlDoNotHaveTagLinearRing: {
        code: -13000,
        description: {
          pt_br: 'O arquivo KML não possui a tag "linear ring".',
          en_us: 'Kml do not have tag linear ring.',
        },
      },
      KmlDoNotHaveTagCoordinates: {
        code: -13001,
        description: {
          pt_br: 'O arquivo KML não possui a tag "coordinates".',
          en_us: 'Kml do not have tag coordinates.',
        },
      },
      KmzIsEmpty: {
        code: -13002,
        description: {
          pt_br: 'O arquivo KMZ informado está vazio.',
          en_us: 'Kmz is empty.',
        },
      },
      KmlIsEmpty: {
        code: -13003,
        description: {
          pt_br: 'O arquivo KML informado está vazio.',
          en_us: 'Kml is empty',
        },
      },
    },

    Budget: {
      MandatoryFillCtc: {
        code: -14000,
        description: {
          pt_br: 'O campo CTC é obrigatório.',
          en_us: 'Mandatory fill ctc.',
        },
      },
      RequiredBranch: {
        code: -14001,
        description: {
          pt_br: 'O campo filial é obrigatório.',
          en_us: 'Required branch.',
        },
      },
      InvalidListBudgetRequestsFilters: {
        code: -14002,
        description: {
          pt_br: 'Os filtros informados para a listagem de orçamento são inválidos.',
          en_us: 'Invalid list budget requests filters.',
        },
      },
      BudgetNotFound: {
        code: -14003,
        description: {
          pt_br: 'O orçamento não foi encontrado.',
          en_us: 'Budget not found.',
        },
      },
      NoNegativeValueAllowed: {
        code: -14004,
        description: {
          pt_br: 'Valores negativos não são permitidos.',
          en_us: 'No negative value allowed.',
        },
      },
      NotAllowedToEdit: {
        code: -14005,
        description: {
          pt_br: 'Não é permitido editar a solicitação de orçamento desta maneira.',
          en_us: 'Not allowed to edit.',
        },
      },
      DescriptionRefuseRequired: {
        code: -14006,
        description: {
          pt_br: 'A descrição do motivo de recusa é obrigatória.',
          en_us: 'Description refuse required.',
        },
      },
      BudgetAlreadyRejected: {
        code: -14007,
        description: {
          pt_br: 'O orçamento ja foi rejeitado.',
          en_us: 'Budget already rejected.',
        },
      },
      BudgetAlreadyApproved: {
        code: -14008,
        description: {
          pt_br: 'O orçamento ja foi aprovado.',
          en_us: 'Budget already approved.',
        },
      },
      BudgetRequestNotFound: {
        code: -14009,
        description: {
          pt_br: 'A Solicitação de orçamento não foi encontrada.',
          en_us: 'Budget request not found.',
        },
      },
      NotesDontBelongToBudgetRequest: {
        code: -14010,
        description: {
          pt_br: 'Estes comentários não pertencem a esta solicitação de orçamento.',
          en_us: 'Notes don\'t belong to budget request.',
        },
      },
      NotesNotFound: {
        code: -14011,
        description: {
          pt_br: 'Os comentários não foram encontrados.',
          en_us: 'Notes not found.',
        },
      },
    },

    EquipamentModel: {
      EquipamentModelNameAlreadyInUse: {
        code: -15000,
        description: {
          pt_br: 'O nome do modelo de equipamento informado ja está em uso.',
          en_us: 'Equipament model name already in use.',
        },
      },
      EquipamentModelNameCantBeNull: {
        code: -15001,
        description: {
          pt_br: 'O nome do modelo de equipamento não pode ser vazio.',
          en_us: 'Equipament model name can\'t be null.',
        },
      },
      EquipamentModelNotFound: {
        code: -15002,
        description: {
          pt_br: 'O modelo de equipamento não foi encontrado.',
          en_us: 'Equipament model not found.',
        },
      },
    },

    Event: {
      EndDateCannotBeLessThanStartDate: {
        code: -16000,
        description: {
          pt_br: 'A data do evento não pode ser anterior a data de início.',
          en_us: 'End date cannot be less than start date.',
        },
      },
      EventNotFound: {
        code: -16001,
        description: {
          pt_br: 'O evento não foi encontrado.',
          en_us: 'Event not found.',
        },
      },
      EventHasAlreadyBeenCanceled: {
        code: -16002,
        description: {
          pt_br: 'O evento ja foi cancelado.',
          en_us: 'event has already been canceled.',
        },
      },
      EventDayNotFound: {
        code: -16003,
        description: {
          pt_br: 'O dia do evento não foi encontrado.',
          en_us: 'Event day not found.',
        },
      },
    },

    Branch: {
      Generic: {
        code: -1,
        description: {
          pt_br: 'Desculpe, houve um problema na requisição. Tente novamente mais tarde.',
          en_us: 'Sorry, there was a problem with the request. Try again later.',
        },
      },
      YouNotPermissionOperation: {
        code: -4003,
        description: {
          pt_br: 'Desculpe, você não tem permissão para realizar esta operação.',
          en_us: 'You do not have permission to perform this operation.',
        },
      },
      NumberImagesExceeded: {
        code: -9020,
        description: {
          pt_br: 'Desculpe, mas você excedeu o número de imagens.',
          en_us: 'Number of images exceeded.',
        },
      },
      BranchNotFound: {
        code: -17000,
        description: {
          pt_br: 'A filial não foi encontrada.',
          en_us: 'Branch not found.',
        },
      },
      ListedBranchNotFound: {
        code: -17001,
        description: {
          pt_br: 'Não foram encontradas filiais para os parametros informados.',
          en_us: 'Listed branch not found.',
        },
      },
      FileTypeNotSupported: {
        code: -9001,
        description: {
          pt_br: 'Desculpe, mas o tipo de arquivo não é suportado.',
          en_us: 'File type not supported.',
        },
      },
    },

    BP: {
      BpNotFoundForSap: {
        code: -18000,
        description: {
          pt_br: 'O BP não foi encontrado no SAP.',
          en_us: 'Bp not found of SAP.',
        },
      },
      BpRequired: {
        code: -18001,
        description: {
          pt_br: 'o BP é obrigatório.',
          en_us: 'Bp required.',
        },
      },
      MatriculationBpNotFound: {
        code: -18002,
        description: {
          pt_br: 'Ocorreu um erro ao validar o BP - informação de matrícula não encontrada.',
          en_us: 'Matriculation bp not found.',
        },
      },
    },

    SAP: {
      SAPTimeOut: {
        code: -19000,
        description: {
          pt_br: 'Sem comunicação com o SAP - Alto tempo de espera ou servidor está inacessível.',
          en_us: 'SAP timeout.',
        },
      },
    },

    NotificationCategory: {
      NotificationCategoryNotFound: {
        code: -20000,
        description: {
          pt_br: 'Categoria de notificação não encontrada.',
          en_us: 'Notification category not found.',
        },
      },
    },

    WordPressApi: {
      WordpressApiNotFound: {
        code: -21000,
        description: {
          pt_br: 'O post da API do Wordpress não foi encontrado.',
          en_us: 'Wordpress post api not found.',
        },
      },
    },
  },
};
